export const IS_CHECKLIST_ENABLED_FEATURE_FLAG = 'isChecklistEnabled';
export const IS_PROPERTY_ASSESSMENT_ENABLED_FEATURE_FLAG =
  'isPropertyAssessmentEnabled';
export const PROPERTY_ASSESSMENT_REGION_IDS_FEATURE_FLAG =
  'propertyAssessmentRegionIds';
export const PROPERTY_ASSESSMENT_USER_IDS_FEATURE_FLAG =
  'propertyAssessmentUserIds';
export const SHOULD_USE_VIMEO_UPLOAD_FEATURE_FLAG = 'shouldUseVimeoUpload';
export const IS_PROPERTY_ASSESSMENT_V2_ENABLED_FEATURE_FLAG =
  'propertyAssessmentV2Enabled';
export const IS_LISTING_REPRESENTATIVE_INFORMATION_ENABLED =
  'isListingRepresentativeInformationEnabled';
export const IS_PAYMENT_LISTING_ENABLED =
  'isPaymentListingEnabled';
export const IS_ENTRY_ACCESS_BFF_MIGRATION_ENABLED =
  'isEntryAccessBffMigrationEnabled';
export const PROBLEM_SESSION_RESCHEDULE_USER_IDS_FEATURE_FLAG =
  'problemSessionRescheduleUserIds';
